<template>
  <div class="px-4 md:px-0 md:col-span-1">
    <h3 class="text-lg font-bold text-gray-900">
      <slot name="title"></slot>
    </h3>
    <p class="mt-1 text-gray-600">
      <slot name="description"></slot>
    </p>
  </div>
</template>
